/**
 *  组织、企业相关 API 地址
 *  @swagger
 */
import { IAjaxConfig } from '../libraries';
export class EnumApiPartnersvr {
  /**
   * @dec 校验企业名称
   */
  readonly partner_check_companyname: IAjaxConfig = {
    url: '/api/gateway/partner-bff/public/api/partnerIdentity/itExistRelIdentityByCompanyName',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 服务站账号激活
   */
  readonly partner_serviceStation_activate: IAjaxConfig = {
    url: '/api/gateway/partner-bff/public/api/serviceStation/activate',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 服务站账号激活页 信息获取
   */
  readonly partner_serviceStation_verifySms: IAjaxConfig = {
    url: '/api/gateway/partner-bff/public/api/serviceStation/verifySms',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec SMB加入组织
   */
  readonly partner_serviceStation_smbJoinOrg: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/employeeApplyIdentity/create4smb',
    method: 'get',
    // loading: true,
    // awaitAuthenticated: false,
  };

  /**
   * @dec 获取加入组织审批人信息
   * @method get
   * @params
   */
  readonly partner_get_employeeApplyIdentity: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/employeeApplyIdentity/getChannelContactsById',
    method: 'get',
  };
}
